"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TextInput = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@icis/ui-kit");
var _flowRight = _interopRequireDefault(require("lodash/flowRight"));
var _noop = _interopRequireDefault(require("lodash/noop"));
var _TextInput = require("./TextInput.style");
var _l10n = require("../../l10n");
var _withHoverState = _interopRequireDefault(require("../HOCs/withHoverState"));
var _withLocale = _interopRequireDefault(require("../HOCs/withLocale"));
const TextInput = _ref => {
  let {
    locale,
    innerRef,
    value,
    onChange,
    onClickIcon,
    icon,
    disabled,
    iconDisabled,
    tallerInput,
    placeHolderKey,
    isValid,
    isError,
    isHovering,
    onBlur,
    onFocus,
    ...props
  } = _ref;
  let iconColor = _uiKit.theme.colours.PRIMARY_1;
  // @ts-ignore
  if (disabled || !isValid) iconColor = _uiKit.theme.colours.NEUTRALS_9;
  return /*#__PURE__*/React.createElement(_TextInput.TextInputWrapper, null, /*#__PURE__*/React.createElement(_TextInput.Input, Object.assign({
    type: "text",
    "data-testid": "textinput",
    value: value,
    placeholder: placeHolderKey ? (0, _l10n.getMessages)(locale)(placeHolderKey) : ''
    // @ts-ignore
    ,
    onChange: e => onChange(e.target.value)
    // @ts-ignore
    ,
    ref: innerRef,
    disabled: disabled,
    tallerInput: tallerInput,
    isValid: isValid,
    isError: isError,
    isHovering: isHovering,
    onBlur: onBlur,
    onFocus: onFocus
  }, props)), icon && /*#__PURE__*/React.createElement(_TextInput.IconButton, {
    onClick: onClickIcon,
    disabled: disabled || iconDisabled,
    tallerInput: tallerInput,
    onBlur: onBlur,
    onFocus: onFocus,
    "data-test-id": "SEARCH"
  }, /*#__PURE__*/React.createElement(_uiKit.Icon, {
    icon: icon,
    color: iconColor,
    size: tallerInput ? '1x' : 'sm'
  })));
};
exports.TextInput = TextInput;
TextInput.defaultProps = {
  innerRef: _noop.default,
  disabled: false,
  iconDisabled: false,
  tallerInput: false,
  onClickIcon: _noop.default,
  icon: null,
  placeHolderKey: null,
  isValid: true,
  isError: false,
  onBlur: _noop.default,
  onFocus: _noop.default
};
var _default = exports.default = (0, _flowRight.default)(_withHoverState.default, _withLocale.default)(TextInput);